/* Price calculator for per-print products: the number of prints in, the total out, using the same rule and the same
   rounding as the price-break discount function, so the figure shown is the one the cart will charge. */
if (!customElements.get('prints-pricing')) {
  customElements.define(
    'prints-pricing',
    class PrintsPricing extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-prints-pricing-config]').textContent);
        this.dialog = this.querySelector('[data-prints-pricing-dialog]');
        this.input = this.querySelector('[data-prints-pricing-quantity]');

        this.querySelector('[data-prints-pricing-open]').addEventListener('click', () => {
          this.dialog.showModal();
          this.update();
        });
        this.querySelector('[data-prints-pricing-close]').addEventListener('click', () => this.dialog.close());
        // A click on the backdrop lands on the dialog itself; one inside the panel does not.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.querySelectorAll('[data-prints-pricing-step]').forEach((button) =>
          button.addEventListener('click', () => {
            this.input.value = this.quantity() + Number(button.dataset.printsPricingStep);
            this.update();
          })
        );
        this.input.addEventListener('input', () => this.update());
      }

      quantity() {
        return Math.min(Math.max(parseInt(this.input.value, 10) || 1, 1), 9999);
      }

      // Mirrors the discount function: the highest break reached, sent as a percentage with 2 decimals,
      // then Shopify rounds the discount amount to the cent.
      price(quantity) {
        const discount = this.config.breaks.reduce(
          (best, b) => (quantity >= b.minQuantity && b.discount > best ? b.discount : best),
          0
        );
        const percent = Number((discount * 100).toFixed(2));
        const full = this.config.base * quantity;
        return { full, total: full - Math.round((full * percent) / 100) };
      }

      update() {
        const quantity = this.quantity();
        const { full, total } = this.price(quantity);
        const money = (cents) => window.theme.formatMoney(cents, this.config.moneyFormat);

        this.querySelector('[data-prints-pricing-total]').textContent = money(total);
        this.querySelector('[data-prints-pricing-unit]').textContent = money(Math.round(total / quantity));
        const saving = this.querySelector('[data-prints-pricing-saving]');
        saving.hidden = total >= full;
        saving.textContent = `Vous économisez ${money(full - total)}`;

        const tiers = [...this.querySelectorAll('[data-prints-pricing-tier]')];
        const active = tiers.filter((row) => quantity >= Number(row.dataset.printsPricingTier)).pop();
        tiers.forEach((row) => row.classList.toggle('is-active', row === active));
      }
    }
  );
}
